import { render, staticRenderFns } from "./DashTopVsls.vue?vue&type=template&id=e889e7a6&"
import script from "./DashTopVsls.vue?vue&type=script&lang=js&"
export * from "./DashTopVsls.vue?vue&type=script&lang=js&"
import style0 from "./DashTopVsls.vue?vue&type=style&index=0&id=e889e7a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports